import moment from "moment";
//@ts-ignore
import trLocale from "moment/locale/tr";

import { useEffect, useState } from "react";
import ts from "typescript";
import { PageHider } from "../components/PageHider";
import { WeeklyPage } from "../components/WeeklyPage";

export const Page1 = ({ pageIndex, subIndex, registerPageIndex }: any) => {
  const [date, setDate] = useState<string>("");

  useEffect(() => {
    moment.locale("tr", trLocale);
    const currentDate = moment();

    const previousFriday = moment().day(moment().day() >= 5 ? 5 : -2);
    const nextMonday = previousFriday.clone().add(3, "days").format("D MMMM");
    const nextFriday = previousFriday.clone().add(7, "days").format("D MMMM");

    const dateRange = `${nextMonday} - ${nextFriday}`;
    setDate(dateRange);
  }, []);
  useEffect(() => {
    registerPageIndex(pageIndex, subIndex, "Giriş");
  }, []);
  return (
    <WeeklyPage pageId={`page-${pageIndex}-${subIndex}`}>
      <div style={{ position: "relative", width: "100%", height: "100%" }}>
        <img
          src="/images/weekly_cover.jpg"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
          alt=""
        />
        <div
          style={{
            position: "absolute",
            left: "60px",
            bottom: "178px",
            textAlign: "center",
            fontSize: "38px",
            fontWeight: "600",
            color: "#000",
            fontFamily: "Open Sans",
            textTransform: "uppercase",
          }}
        >
          {date}
        </div>
      </div>
    </WeeklyPage>
  );
};
